'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uxcore = require('@ux/uxcore2');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _lpConnection = require('./live-person/lp-connection.js');

var _lpConnection2 = _interopRequireDefault(_lpConnection);

var _storage = require('./storage');

var _storage2 = _interopRequireDefault(_storage);

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _conversation = require('./store/actions/conversation');

var _agentUtils = require('./live-person/agent-utils.js');

var _agentUtils2 = _interopRequireDefault(_agentUtils);

var _trafficManager = require('./traffic-manager.js');

var _trafficManager2 = _interopRequireDefault(_trafficManager);

var _configureTag = require('./live-person/configure-tag.js');

var _configureTag2 = _interopRequireDefault(_configureTag);

var _lpMonitor = require('./live-person/lp-monitor.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var accountId = '30187337';
var getAgentSkill = function getAgentSkill(env) {
  return env === 'prod' ? 'bot_to_english_en-us' : 'Bot_Dev';
};
var phoneEscalateEvent = 'chatoffline-phone';
var chatEndEvent = 'return-welcome';
var chatAbortEvent = 'abort-welcome';

var liveEngageChatId = window.sessionStorage && window.sessionStorage.getItem('liveEngageChatId') || (0, _v2.default)();
window.sessionStorage && window.sessionStorage.setItem('liveEngageChatId', liveEngageChatId);

var livePersonReadyIntervalMs = 200;
var livePersonReadyTries = 150;

var helpBot = null;

var url = 'https://lpcdn.lpsnmedia.net/api/chat/public/lpChat.min.js';
var events = ['onAddLine', 'onAgentTyping', 'onEngagement', 'onError', 'onInfo', 'onInit', 'onLine', 'onRequestChat', 'onStart', 'onState', 'onStop', 'onVisitorDisposed'];

var lpConn = null;
var sessionRefresh = false;

initLivePerson();

function initLivePerson() {
  window.helpBotLiveEngageDivClick = function (data) {
    lpConn.engagementData = data;
  };
}

function getLiveEngageChildDiv() {
  var liveEngageDiv = document.getElementById('helpBotLiveEngageDivId');
  if (liveEngageDiv) {
    var childDiv = liveEngageDiv.children[0];
    if (childDiv) {
      return childDiv;
    }
  }
  return null;
}

function onLivePersonReady(next) {
  var tries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : livePersonReadyTries;

  if (getLiveEngageChildDiv()) {
    return next();
  }
  setTimeout(function () {
    if (!getLiveEngageChildDiv() && tries) {
      onLivePersonReady(next, --tries);
    } else {
      return next();
    }
  }, livePersonReadyIntervalMs);
}

var initialize = function initialize(helpBotRef) {
  helpBot = helpBotRef;

  if (!lpConn) {
    lpConn = new _lpConnection2.default(helpBot.props.sessionId, helpBot.state.chatbotsApiBaseUrl);
  }

  if (isActiveChatSession()) {
    helpBot.setState({ liveAgent: true, liveAgentConnecting: true });
    sessionRefresh = true;
    onLivePersonReady(function () {
      transferToAgent();
    });
  }
};

function isActiveChatSession() {
  return !!_storage2.default.getItem('lpSessionUID');
}

function getEstimatedChatWaitTime() {
  return _storage2.default.getItem('estimatedChatWaitTime') || 'unknown';
}

function setEstimatedChatWaitTime(estimatedChatWaitTime) {
  _storage2.default.setItem('estimatedChatWaitTime', estimatedChatWaitTime);
}

function getEstimatedPhoneWaitTime() {
  return _storage2.default.getItem('estimatedPhoneWaitTime') || 'unknown';
}

function setEstimatedPhoneWaitTime(estimatedPhoneWaitTime) {
  _storage2.default.setItem('estimatedPhoneWaitTime', estimatedPhoneWaitTime);
}

function setEstimatedWaitTime(response) {
  var escalateResp = response.queryResult.escalate;

  if (escalateResp) {
    setEstimatedChatWaitTime(escalateResp.estimatedChatWaitTime);
    setEstimatedPhoneWaitTime(escalateResp.estimatedPhoneWaitTime);

    helpBot.setState({ liveAgentAvailable: escalateResp.chatAvailability });
  }
}

function setVisitorTyping(value) {
  var chat = lpConn && lpConn.chat;
  if (chat && lpConn.chatState === 'chatting') {
    chat.setVisitorTyping({ typing: value });
  }
}

function getShopperId() {
  var infoIdp = _uxcore.utils.cookie.get('info_idp');
  return infoIdp && JSON.parse(infoIdp).info_shopperId;
}

function sendConversationToCRM(chatbotsApiBaseUrl) {

  try {
    var shopperId = getShopperId();
    if (shopperId) {
      var chatbotApiUrl = chatbotsApiBaseUrl + '/postToCRM';

      var options = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      var body = {
        shopperId: shopperId,
        conversationText: getAgentNotes().join('\n')
      };

      _uxcore.utils.request.post(chatbotApiUrl, body, options, function (err) {
        if (err) {
          throw new Error(err);
        }
      });
    }
  } catch (err) {
    throw new Error(err);
  }
}

function getAgentNotes() {
  var userContext = helpBot.props.intl.messages['Support:HelpBot:LiveEngage:UserContext'];
  var botContext = helpBot.props.intl.messages['Support:HelpBot:LiveEngage:BotContext'];

  var conversationHistory = helpBot.props.conversation.filter(function (conv) {
    return conv.msgType === 'user' || conv.msgType === 'text';
  }).map(function (conv) {
    return conv.msgType === 'user' ? userContext + conv.msg : botContext + conv.msg.text.text[0];
  });

  var agentName = 'your LiveEngage display name.';
  var chattingWith = helpBot.props.intl.messages['Support:HelpBot:LiveEngage:WhatCustomerSees'].replace('{agentName}', agentName);

  var productId = helpBot.state.productId || '';
  conversationHistory.unshift('**** product: ' + productId + ' ****');
  conversationHistory.unshift('**** url: ' + (window.location && window.location.href || 'none') + ' ****');
  conversationHistory.unshift('**** ' + chattingWith + ' ****');

  return maskPin(conversationHistory);
}

// Replace any standalone occurrence of 4 digit number with XXXX
function maskPin(conversationData) {
  return conversationData.map(function (conv) {
    return conv.replace(/\b\d{4}\b/g, 'XXXX');
  });
}

function connect() {
  if (lpConn) {
    var childDiv = getLiveEngageChildDiv();
    if (childDiv) {
      childDiv.click();
    }

    helpBot.setState({ liveAgentConnecting: true });
    loadLivePersonChatJs(function () {
      if (!isActiveChatSession()) {
        showClockWaitTime();
      }

      var agentNotes = getAgentNotes();
      sendSdes();

      lpConn.initChat(accountId, getAgentSkill(helpBot.props.env));
      lpConn.startChat(agentNotes);

      window.localStorage.setItem('liveEngageChatId', liveEngageChatId);

      registerEvents(handleLiveAgentResponse);
    });

    _trafficManager2.default.sendChatStartEvent(helpBot.props.sessionId, helpBot.state.productId);
  }
}

function sendSdes() {
  window.utag_data = window.utag_data || {};
  var utag = window.utag_data;
  window.gdchat = window.gdchat || {};
  var productId = helpBot.state.productId || '';

  (0, _configureTag2.default)(window, productId, utag, function () {});
}

function handleLiveAgentResponse(err, resp) {
  if (err) {
    return;
  }

  var dispatch = _store2.default.dispatch,
      getState = _store2.default.getState;


  if (resp.evt === 'connected' && !sessionRefresh && helpBot.state.liveAgentConnecting === true) {
    helpBot.setState({ liveAgentConnecting: false });
    var newMessage = {
      msgType: 'agentImage',
      agentName: _agentUtils2.default.getAgentName(),
      agentIconPath: _agentUtils2.default.getAgentImage(),
      timestamp: Date.now()
    };
    var updatedConversation = helpBot.props.conversation.filter(function (conv) {
      return conv.msgType !== 'agentTransfer';
    }).concat(newMessage);
    (0, _conversation.conversationSet)(updatedConversation)(dispatch);
  } else if (resp.evt === 'agentTyping') {
    helpBot.setState({ liveAgentTyping: resp.value });
  } else if (resp.evt === 'msgReceived') {
    (0, _conversation.conversationAppend)({
      agentIconPath: _agentUtils2.default.getAgentImage(),
      agentName: _agentUtils2.default.getAgentName(),
      msgType: 'liveAgentText',
      text: resp.text,
      timestamp: Date.now()
    })(dispatch, getState);

    helpBot.handleChatMessage(resp.text);
  } else if (resp.evt === 'offline') {
    helpBot.appendTextToConversation(helpBot.props.intl.messages['Support:HelpBot:LiveEngage:Offline']);
    helpBot.triggerEvent(phoneEscalateEvent);
    endConnection(resp.evt);
  } else if (resp.evt === 'connectionEnded') {
    endConnection(resp.evt);
  } else if (resp.evt === 'error' || resp.evt === 'visitorDisposed') {
    endConnection(resp.evt);
  } else if (resp.evt === 'connected' && sessionRefresh && helpBot.state.liveAgentConnecting === true) {
    helpBot.setState({ liveAgentConnecting: false });
  }
}

function getConnectionObject() {
  return lpConn;
}

function loadLivePersonChatJs(callback) {
  var newScript = document.createElement('script');
  newScript.type = 'text/javascript';
  newScript.src = url;
  document.head.appendChild(newScript);
  newScript.onload = callback;
}

function showClockWaitTime() {
  var newMessage = {
    msgType: 'agentTransfer',
    estimatedChatWaitTime: getEstimatedChatWaitTime()
  };

  var dispatch = _store2.default.dispatch,
      getState = _store2.default.getState;

  (0, _conversation.conversationAppend)(newMessage)(dispatch, getState);
}

function transferToAgent() {
  connect();
}

function sendMessage(msg) {
  if (lpConn && msg) {
    lpConn.sendConversation(msg);
  }
}

/**
 * Indicates whether auto escalation is necessary
 *
 * @returns {boolean} True/false value representing whether escalation is needed
 *
 * @param {Object} response The response object from Dialogflow
 * @param {number} autoEscalateThreshold Maximum sentiment for which escalation should occur
 * @private
 */
function isAutoEscalation(response, autoEscalateThreshold) {
  return response.queryResult.sentimentAnalysisResult && response.queryResult.sentimentAnalysisResult.queryTextSentiment.score < autoEscalateThreshold;
}

/**
 * @returns {string} the text string of the message
 * @param {Object} message for the event
 * processes the events data and extracts the text
 * @private
 */
function processMessage(message) {
  var lastSequenceId = lpConn.getLastSequenceId();

  if (lpConn.chatState === 'chatting' && message.source === 'agent' && Number(message.sequenceId) > Number(lastSequenceId)) {
    lpConn.setLastSequenceId(message.sequenceId);
    return message.text;
  }

  return null;
}

function registerEvents(callback) {

  events.forEach(function (evt) {
    lpConn.on(evt, function (data) {
      data.evt = evt;
      (0, _lpMonitor.notify)(evt, data, helpBot.props.sessionId, helpBot.state.chatbotsApiBaseUrl);
      if (data.evt === 'onStart' && data.state === 'chatting') {
        callback(null, {
          evt: 'connected'
        });
      } else if (data.evt === 'onState') {
        if (data.state === 'WAITING') {
          // The visitor is queued and waiting for chat.
          callback(null, {
            evt: 'waiting'
          });
        } else if (data.state === 'ended') {
          callback(null, {
            evt: 'connectionEnded'
          });
        }
      } else if (data.evt === 'onLine') {
        var resp = null;
        if (data.lines && data.lines.length) {
          resp = processMessage(data.lines[0]);
        }

        if (resp) {
          callback(null, {
            evt: 'msgReceived',
            text: resp
          });
        }
      } else if (data.evt === 'onAgentTyping') {
        callback(null, {
          evt: 'agentTyping',
          value: data && data.agentTyping
        });
      } else if (data.evt === 'onError') {
        if (data.error && (data.error.reason === 'no-available-agents' || data.error.reason === 'cannot get the engagment with live person')) {
          callback(null, {
            evt: 'offline'
          });
        } else {
          callback(null, {
            evt: 'error'
          });
        }
      } else if (data.evt === 'onVisitorDisposed') {
        callback(null, {
          evt: 'visitorDisposed'
        });
      }
    });
  });
}

function appendEndConversationMessage() {
  var dispatch = _store2.default.dispatch;


  var endMessage = {
    msgType: 'agentEnded',
    agentName: _agentUtils2.default.getAgentName(),
    timestamp: Date.now()
  };
  var updatedConversation = helpBot.props.conversation.filter(function (conv) {
    return conv.msgType !== 'agentTransfer';
  }).concat(endMessage);

  (0, _conversation.conversationSet)(updatedConversation)(dispatch);
  helpBot.triggerEvent(chatEndEvent);

  _trafficManager2.default.sendChatEndEvent(helpBot.props.sessionId, helpBot.state.productId);
}

function endConnection(evt) {
  if (lpConn && helpBot.state.liveAgent) {
    lpConn.endChat();
    sessionRefresh = false;
    var visitorNotEngaged = ['visitorClosed', 'offline'].includes(evt);
    if (!visitorNotEngaged) {
      appendEndConversationMessage();
    }
    helpBot.setState({
      liveAgent: false,
      liveAgentConnecting: false
    });
  }
  if (evt === 'visitorClosed') {
    helpBot.triggerEvent(chatAbortEvent);
  }
  (0, _lpMonitor.notify)('endConnection', evt, helpBot.props.sessionId, helpBot.state.chatbotsApiBaseUrl);
}

exports.default = {
  connect: connect,
  endConnection: endConnection,
  getConnectionObject: getConnectionObject,
  getEstimatedChatWaitTime: getEstimatedChatWaitTime,
  getEstimatedPhoneWaitTime: getEstimatedPhoneWaitTime,
  handleLiveAgentResponse: handleLiveAgentResponse,
  initialize: initialize,
  isAutoEscalation: isAutoEscalation,
  maskPin: maskPin,
  phoneEscalateEvent: phoneEscalateEvent,
  processMessage: processMessage,
  sendConversationToCRM: sendConversationToCRM,
  sendMessage: sendMessage,
  setEstimatedWaitTime: setEstimatedWaitTime,
  setVisitorTyping: setVisitorTyping,
  transferToAgent: transferToAgent
};